import React from 'react';
import { Text, Flex, Stack } from '@tapresearch/ui/components';
import { Square } from '@chakra-ui/react';

import { LegendSvgProps } from '@nivo/legends';
import { BarDatum } from '@nivo/bar';
import { useCustomBarLegend } from './useCustomBarLegend';
import { TapAnswer } from '../../../../api';

export interface CustomBarLegendsProps {
  data: BarDatum[];
  answersById: Record<string, TapAnswer['attributes']>;
  hiddenSeries?: string[];
  layerProps?: Omit<LegendSvgProps, 'data'>;
  layerData?: LegendSvgProps['data'];
  toggleSerie?: (serieId: string) => void;
}

export function CustomBarLegends({
  data,
  answersById,
  layerData,
  hiddenSeries = [],
  toggleSerie = () => {
    //
  },
}: CustomBarLegendsProps) {
  const legendsData = useCustomBarLegend({
    data,
    layerData,
    hiddenSeries,
    answersById,
  });

  return data ? (
    <Stack>
      {legendsData.map((legendData, index) => (
        <Flex
          key={`legend-${index}`}
          alignItems="center"
          w="228px"
          cursor="pointer"
          _hover={{ fontWeight: 'bold' }}
          onClick={() => toggleSerie(legendData.id)}
        >
          <Square size="6" borderRadius="sm" bgColor={legendData.color} />

          <Text fontSize="sm" ml="2" textColor={legendData.textColor}>
            {legendData.label}
          </Text>
        </Flex>
      ))}
    </Stack>
  ) : null;
}
